import React, { Fragment, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { FaEdit, FaTrash } from "react-icons/fa";
import "./edituser.scss";
import axios from "axios";
import Alert from "react-bootstrap/Alert";
import { getToken } from "../../auth/authConfig";

export default function EditUser({
  email,
  FirstName,
  LastName,
  getUserList,
  id,
  group_id,
  Company,
  userinfo,
}) {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [issuccess, setsuccess] = useState(false);
  const [iserror, seterror] = useState(false);

  const [formData, setFormData] = useState({
    FirstName: FirstName,
    LastName: LastName,
    Email: email,
    userId: id,
    Role: group_id,
    Company: Company,
  });

  console.log("EditUser Component Rendered", formData);

  const companyOptions = ["Aays", "Mars", "LRQA", "BV", "BSI"];

  const cbRoleOptions = [
    {
      value: 104,
      label: "CB Admin (Lead Auditor)",
    },
    {
      value: 108,
      label: "CB Admin (Tech Reviewer)",
    },
    {
      value: 102,
      label: "Lead Auditor",
    }
    ,{
      value: 105,
      label: "Tech Reviewer",
    },
  ];
  const superAdminRoleOptions = [
    {
      value: 100,
      label: "Unit Admin",
    },
    {
      value: 101,
      label: "Super Admin",
    },
    {
      value: 103,
      label: "Mars Admin",
    },
    {
      value: 104,
      label: "CB Admin (Lead Auditor)",
    },
    {
      value: 108,
      label: "CB Admin (Tech Reviewer)",
    },

  ];

  const techReviewerRoleOptions = [
    {
      value: 105,
      label: "Tech Reviewer",
    },
  ];

  const userinfoRole = userinfo?.user_group_id;
  console.log("user_group_id", userinfoRole);
  const marsAdminRoleOptions =
    userinfoRole === 104
      ? [...cbRoleOptions]
      :  userinfoRole === 108
      ? [...cbRoleOptions] :  [...superAdminRoleOptions];

  useEffect(() => {
    setFormData({
      FirstName: FirstName,
      LastName: LastName,
      Email: email,
      userId: id,
      Role: group_id,
      Company: Company,
    });
  }, [email, FirstName, LastName, id, Company, group_id]);
  console.log(formData);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      let updatedData = {
        ...prevData,
        [name]: name === "Role" ? parseInt(value, 10) : value, // Convert Role to number
      };

      // Check using numbers
      if (name === "Role" && [100, 101, 103].includes(updatedData.Role)) {
        updatedData.Company = "Mars";
      }

      return updatedData;
    });
  };

  const handleReset = () => {
    setFormData({
      FirstName: FirstName,
      LastName: LastName,
      Email: email,
      Role: group_id,
      userId: id,
      Company: Company,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsloading(true);
    // Perform the submit logic here
    console.log("Form Submitted", formData);
    const token = await getToken();

    // setOpen(false); // Close the dialog after submission
    const data = {
      email: formData.Email,
      userGroupId: formData.Role,
      userId: formData.userId,
      firstName: formData.FirstName,
      lastName: formData.LastName,
      company: formData.Company,
    };

    const url = `${process.env.REACT_APP_SERVER_URL}/api/user/editUser`;
    const header = {
      headers: {
        "oidc-token": token,
      },
    };

    axios
      .post(url, data, header)

      .then(function (response) {
        if (response.status === 200) {
          // console.log(response);
          setIsloading(false);
          setsuccess(true);
          getUserList();
          handleReset();
          setTimeout(() => {
            setsuccess(false);
          }, 5000);
        }
      })
      .catch(function (error) {
        // console.log(error);
        setIsloading(false);
        seterror(true);
        setTimeout(() => {
          seterror(false);
        }, 5000);
      });
  };

  return (
    <div>
      <Fragment>
        <div onClick={handleClickOpen}>
          <FaEdit className="editcls" title="edit" />
        </div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          id="editableForm"
        >
          <DialogTitle id="alert-dialog-title">{"User Management"}</DialogTitle>
          <DialogContent>
            <div id="edit-form">
              <form onSubmit={handleSubmit}>
                <div className="form-component-container">
                  <div className="input-box">
                    <label className="input-label">First Name</label>
                    <input
                      className="input-field"
                      id="FirstName"
                      name="FirstName"
                      placeholder="First Name"
                      value={formData.FirstName}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="input-box">
                    <label className="input-label">Last Name</label>
                    <input
                      className="input-field"
                      id="LastName"
                      name="LastName"
                      placeholder="Last Name"
                      value={formData.LastName}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="input-box">
                    <label className="input-label">Email</label>
                    <input
                      className="input-field"
                      id="Email"
                      name="Email"
                      placeholder="Email"
                      disabled
                      type="email"
                      value={formData.Email}
                    />
                  </div>

                  <div className="input-box">
                    <label className="input-label">Role</label>
                    <select
                      className="input-field"
                      id="Role"
                      name="Role"
                      required
                      onChange={handleChange}
                      value={formData.Role}
                    >
                      <option disabled>Select Role</option>
                      {marsAdminRoleOptions.map((role) => (
                        <option key={role.value} value={role.value}>
                          {role.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="input-box">
                    <label className="input-label">Company</label>
                    <select
                      className="input-field"
                      id="Company"
                      name="Company"
                      required
                      onChange={handleChange}
                      value={formData.Company}
                      disabled={
                        (userinfoRole === 104 || userinfoRole === 108) ||
                        !(formData.Role === 104 || formData.Role === 105 || formData.Role === 108)
                      }
                    >
                      <option value="" disabled>
                        Select Company
                      </option>

                      {companyOptions.map((company) => (
                        <option key={company} value={company}>
                          {company}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="button-container">
                  <button
                    type="button"
                    className="reset_btn"
                    onClick={handleReset}
                  >
                    Reset
                  </button>

                  <Button
                    disabled={isLoading}
                    className="submit_btn"
                    type="submit"
                  >
                    {isLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        <span style={{ paddingLeft: "10px" }}>Updating..</span>
                      </>
                    ) : (
                      "Update"
                    )}
                  </Button>
                </div>
              </form>

              {issuccess && (
                <div>
                  <Alert
                    style={{ position: "absolute", right: "20px", top: "10px" }}
                    variant="success"
                  >
                    <p className="mb-0">User Successfully Registered</p>
                  </Alert>
                </div>
              )}

              {iserror && (
                <div>
                  <Alert
                    style={{ position: "absolute", right: "20px", top: "0px" }}
                    variant="danger"
                  >
                    <p className="mb-0">
                      Something went wrong, Please try after sometime
                    </p>
                  </Alert>
                </div>
              )}
            </div>
          </DialogContent>
        </Dialog>
      </Fragment>
    </div>
  );
}
